import { css } from 'aphrodite';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { Toggle } from '../../../../components/Toggle';
import { grayIconFill } from '../../../../styles/colors';
import { FormFieldWrapper } from '../../shared/components/FormFieldWrapper';
import { styleSheet } from '../styles';
import { EventRegistrationFormData } from '../utils';

// Component uses form context directly, no props needed
export const VisibilitySettings: React.FC = () => {
	const { control } = useFormContext<EventRegistrationFormData>();

	return (
		<section className={css(styleSheet.section)}>
			<h3 className={css(styleSheet.sectionTitle)}>Visibility</h3>
			<p className={css(styleSheet.sectionDescription, styleSheet.sectionDescriptionNoWrap)}>
				Control where this event appears on your public events landing page. When enabled, this event will be visible to
				anyone who visits your events page.
			</p>

			<FormFieldWrapper
				name='showOnHomepage'
				control={control}
				title='Show on Events Landing Page'
				description='Display this event on your public events landing page'
			>
				{({ value, onChange }) => (
					<Toggle
						id='show-on-homepage-toggle'
						isOn={value}
						onToggleCheckChanged={() => onChange(!value)}
						uncheckedColor={grayIconFill}
					/>
				)}
			</FormFieldWrapper>
		</section>
	);
};
